module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mensagem:")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "readMessageContent"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn default btn-xs g pull-left",
    attrs: {
      "href": ""
    }
  }, [_vm._v("1/2000")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-right"
  }, [_c('button', {
    staticClass: "btn green-jungle btn-block",
    attrs: {
      "id": "readMessageSend"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Enviar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425b6d7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-reply/new/new.vue
// module id = 1057
// module chunks = 1